export const CATEGORIES = [
  "atp250",
  "atp500",
  "grandslam",
  "masters",
  "wta1000",
  "wta250",
  "wta500",
];

// Mapping of tourID to their corresponding tour names
export const tourIdMap: { [key: string]: string } = {
  "bihlpcatrk45hxoye65ejz27d": "ATP",
  "bihmimk46tnexl279lgqjku7d": "WTA",
};